import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        payment: {},
        lstPayments: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'PAGAMENTO', key: 'paymentName', align: 'center' }
        ],
    },
    getters: {
        getPayment(state) {
            let payment = { ...state.payment }
            return payment
        }
    },
    mutations: {
        setPayment(state, payment) {
            state.payment = payment
        },
        setLstPayments(state, lstPayments) {
            state.lstPayments = lstPayments
        },
        appendLstPayments(state, items) {
            state.lstPayments = [...state.lstPayments, ...items]
        },
        clearLstPayments(state) {
            state.lstPayments = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.payment = {}
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Payments/Insert',
                getters.getPayment
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Pagamento salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Payments/Update',
                getters.getPayment
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Pagamento atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset }) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Payments/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstPayments", response.data.items)
            } else {
                commit("appendLstPayments", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({commit}, paymentId) {
            const response = await api.get(
                `/Payments/Find/${paymentId}`,
            )
            commit('setPayment', response.data)
            commit('setUpdating')

            return true
        },

        async findAll({ commit }) {
            const response = await api.get(
                `/Payments/FindAll/`,
            )
            commit('setLstPayments', response.data)
            
            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Payments/Delete/${getters.getPayment.paymentId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        }
    }
}